<template>
  <div class="cookie_banner" :class="{ view: showPopup }">
    <span>
      <span>На&nbsp;нашем сайте мы&nbsp;используем файлы cookie и&nbsp;аналогичные технологии, чтобы обеспечить вам, нашим пользователям, удобную работу с&nbsp;контентом сайта. </span>
      <span>Оставаясь на&nbsp;сайте и&nbsp;продолжая читать нас, вы&nbsp;подтверждаете свое согласие на&nbsp;использование файлов cookie в&nbsp;соответствии с&nbsp;политикой.</span>
      Для улучшения работы сайта и&nbsp;его адаптации к&nbsp;вашим потребностям мы&nbsp;используем файлы cookie&nbsp;&mdash; подробнее cookie и&nbsp;как их&nbsp;отключить можете <router-link to="/cookie-policy">прочитать тут</router-link>. С&nbsp;подробной информацией о&nbsp;том, как мы&nbsp;обрабатываем ваши данные, вы&nbsp;можете ознакомиться в&nbsp;нашей <router-link to="/privacy-policy">Политике обработки персональных данных</router-link> и&nbsp;<router-link to="/user-agreement">пользовательским соглашением</router-link>.
    </span>
    <button class="btn_orange agree_btn" type="button" @click="acceptCookies">Cогласен</button>
  </div>
</template>

<script>
export default {
  name: 'CookiePopup',
  data() {
    return {
      showPopup: false
    }
  },
  mounted() {
    // Проверяем sessionStorage - показывать ли попап
    const cookieAccepted = sessionStorage.getItem('cookieAccepted');
    
    if (!cookieAccepted) {
      // Небольшая задержка перед показом
      setTimeout(() => {
        this.showPopup = true;
      }, 500);
    }
  },
  methods: {
    acceptCookies() {
      // Сохраняем в sessionStorage (на сессию)
      sessionStorage.setItem('cookieAccepted', 'true');
      this.showPopup = false;
    }
  }
}
</script>

<style src="./cookie-popup.less" lang="less" />